import { Button, Modal } from 'antd';
import alertIllustration from '../../assets/images/alert-illustration.svg';

export default function LakeBookingInformationModal({
  visible,
  onClose,
  bookingInfo,
}) {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      width={'min(95%, 40rem)'}
      title={null}
      footer={null}
      closable={false}
      maskClosable
      centered
    >
      <h2 className={'gSemiBold txt-center w-full fs-26'}>
        Important Booking Information
      </h2>
      <div className={'display-flex-column gap-2r'}>
        <img
          style={{
            maxWidth: '90%',
            width: '4rem',
            margin: '0.5rem auto -0.5rem',
          }}
          src={alertIllustration}
          alt={'Illustration of an exclamation mark'}
        />
        <div className={'gMedium txt-center text-area-display fs-16'}>
          {bookingInfo}
        </div>
        <Button
          className={'w-full sb-blue-bg br10 white pd-8 h-fit gSemiBold fs-18'}
          onClick={onClose}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
}
